module.exports = __webpack_public_path__ + "media/connectivity-slide2.27a1255f.mp4";